import { FC, useState } from 'react';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { CustomerManagement } from '@/libs/fleet-api/services/types';
import ManagerProfileForm, {
	useManagerProfileForm,
} from '../forms/ManagerProfileForm';

type ManagerProfileData = CustomerManagement & {
	index?: number;
};

type ModalData =
	| { type: 'new' }
	| {
			type: 'edit';
			data: ManagerProfileData;
	  };

export const useManagerProfileModal = (
	onSubmit: (type: ModalData['type'], data: ManagerProfileData) => void,
) => {
	const [modalData, setModalData] = useState<ModalData>();

	return {
		data: modalData,
		isOpen: Boolean(modalData),
		open: (data: ModalData) => {
			setModalData(data);
		},
		close: () => setModalData(undefined),
		onSubmit,
	};
};

const ManagerProfileModal: FC<ReturnType<typeof useManagerProfileModal>> = (
	props,
) => {
	const managerProfileForm = useManagerProfileForm((values) => {
		props.close();
		if (props.data?.type === 'edit') {
			props.onSubmit(props.data!.type, {
				...values,
				index: props.data!.data.index,
			});
		} else {
			props.onSubmit(props.data!.type, values);
		}
	});
	const { form } = managerProfileForm;

	return (
		<FleetModal
			open={props.isOpen}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onCancel={() => props.close()}
			onOk={form.submit}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data?.type === 'edit') {
					form.setFieldsValue(props.data.data);
				}
			}}
		>
			<FleetTitle>Edit Profil Pengurus</FleetTitle>
			<ManagerProfileForm {...managerProfileForm} />
		</FleetModal>
	);
};

export default ManagerProfileModal;
